import type { PanelFilters } from '@content-search/domain';
import { getLanguageOptions } from '@content-search/utils';
import { Select } from '@soteria/design-system-ve';
import { useCallback, useMemo } from 'react';

import * as styles from './FilterPanel.css';

interface LanguageFilterProps {
  panelFilters: PanelFilters;
  updateFilters: (updates: Partial<PanelFilters>) => void;
  isLoading: boolean;
}

export function LanguageFilter({ panelFilters, updateFilters, isLoading }: LanguageFilterProps) {
  const isLanguageDisabled = useMemo(() => panelFilters.contentTypes.length > 0 && !panelFilters.contentTypes.includes('audio'), [panelFilters.contentTypes]);

  const handleLanguageChange = useCallback(
    (value: string) => {
      updateFilters({
        languageDetected: value === 'all' ? undefined : value,
      });
    },
    [updateFilters]
  );

  return (
    <div className={styles.filterSection}>
      <div className={styles.filterLabel} style={{ opacity: isLanguageDisabled ? 0.5 : 1 }}>
        Language Detected {isLanguageDisabled && '(Audio only)'}
      </div>
      <div style={{ opacity: isLanguageDisabled ? 0.5 : 1 }}>
        <Select
          searchable
          aria-label="Filter by audio language detected"
          disabled={isLoading || isLanguageDisabled}
          options={getLanguageOptions()}
          placeholder="All"
          searchPlaceholder="Search languages..."
          value={panelFilters.languageDetected || 'all'}
          onChange={handleLanguageChange}
        />
      </div>
    </div>
  );
}
